<template>
  <v-menu :key="presentation.nombre" v-model="presentation.open" full-width offset-x>
    <template slot="activator" slot-scope="{ on }">
      <div v-ripple class="my-event" v-on="on" v-html="presentation.nombre"></div>
    </template>
    <v-card color="grey lighten-4" min-width="350px" flat class="custom-font-regular">
      <v-toolbar color="green" dark dense>
        <v-toolbar-title v-html="presentation.nombre"></v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <span class="grey--text">Estado:</span><br>
        <pre>{{ presentation.estadoDisplay }}</pre>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small flat color="primary" @click="goDetail(presentation)">Ver Detalle</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    presentation: Object,
    hide: Boolean
  },

  methods: {
    goDetail (presentation) {
      this.$router.push({ name: 'presentacion', params: { id: presentation.pk } })
    }
  },

  watch: {
    'hide' () {
      if (this.hide) {
        this.presentation.open = false
      }
    }
  }
}
</script>

<style scoped>
.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  background-color: #52b051;
  color: #ffffff;
  border: 1px solid #52b051;
  width: 100%;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
}
pre {
  font-family: 'Roboto', sans-serif;
  line-height: 1.5;
}
</style>
